<template>
    <div class="h-full">
        <div
            v-if="options.length"
            class="h-full flex items-center justify-start">
            <button
                v-if="mainItem && mainItem.permissions"
                @click="mainItem.click(data)">
                {{ mainItem.label }}
            </button>
            <hts-dropdown
                class="flex items-center"
                :options="options"
                :placement="'left'"
                label-key="label"
                @click="(action) => dropdownMenuClick(action)">
                <template #reference>
                    <div class="flex items-center text-cyan-600">
                        <span v-if="!mainItem || !mainItem.permissions">
                            Chọn
                        </span>
                        <hi-chevron-down-icon
                            class="h-6 w-6"
                            aria-hidden="true" />
                    </div>
                </template>
            </hts-dropdown>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})
const { params } = toRefs(props)
const store: any = $store()

const items: any = computed(() => params?.value?.items || [])
const mainItem = computed(() => params?.value?.main || null)
const data = computed(() => params?.value?.data || null)
const isArchive = computed(() => {
  const storeKey: any = typeof params?.value?.storeKey === 'string' ? params.value.storeKey : ''
  if (storeKey && params?.value?.storeName) {
    return store[storeKey][`getIs${params?.value?.storeName}Archive`]
  }
  return true
})
const options = computed(() => {
  const result: any = []
  if (params?.value?.storeKey && params?.value?.storeName) {
    items.value.forEach((item: any) => {
      if (item.permissions) {
        if (!(typeof item.validate === 'function')) {
          if (isArchive.value) {
            if (item.isArchive || item.isAll) {
              result.push(item)
            }
          } else if (!item.isArchive) {
            result.push(item)
          }
        } else if (item.validate(params?.value?.data)) {
          if (isArchive.value) {
            if (item.isArchive || item.isAll) {
              result.push(item)
            }
          } else {
            result.push(item)
          }
        }
      }
    })
  }
  return result
})
const handleClick = (item: any) => {
  const { click } = item
  if (typeof click === 'function') {
    item.click(data || {})
  }
}
const handleValidate = (item: any) => {
  const { validate } = item
  if (typeof validate === 'function') {
    return validate(data)
  }
  return true
}
const dropdownMenuClick = (action: any) => {
  action.click(data.value || {})
}
</script>
